export default {
  EmptyState: {
    title: 'Add your first restaurant',
    description: "You don't have any restaurants yet. Create one to start setting it up and taking orders.",
    cta: 'New Restaurant',
  },
};
